import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {ReactiveFormsModule} from '@angular/forms';
import {CoreModule} from '@catcore/core.module';
import {ProjectDetailsModule} from '@catdetails/project-details.module';
import {FeatureGgwImplementationsModule} from '@catmodules/models/feature-ggw-implementations/feature-ggw-implementations.module';
import {FeaturePortModule} from '@catmodules/models/feature-port/feature-port.module';
import {ParametersModule} from '@catmodules/models/parameters/parameters.module';
import {ExplorerModule} from '@catmodules/widgets/explorer/explorer.module';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';
import {InputSwitchModule} from 'primeng/primeng';
import {ModelEditorComponent} from '@catmodules/model-editor/components/model-editor.component';
import {GgwDeviceParamsModule} from "@catmodules/models/ggw-device-params/ggw-device-params.module";
import {GgwDeviceModule} from "@catmodules/models/ggw-device/ggw-device.module";
import {AddToRelationComponent} from "@catmodules/model-editor/components/add-to-relation.component";
import {DropdownModule} from 'primeng/primeng';

const publicComponents = [
  ModelEditorComponent,
  AddToRelationComponent
];

const imports = [
  CommonModule,
  RouterModule,
  CoreModule,
  ReactiveFormsModule,
  ProjectDetailsModule,
  UIBaseModule,
  UIFormModule,
  InputSwitchModule,
  FeatureGgwImplementationsModule,
  GgwDeviceModule,
  GgwDeviceParamsModule,
  ExplorerModule,
  FeaturePortModule,
  ParametersModule,
  DropdownModule,
];
const declarations = [
  ...publicComponents
];
const entryComponents = [...publicComponents];

@NgModule({
  entryComponents,
  imports,
  declarations
})
export class ModelEditorModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/model-editor/model-editor.module.ts